/*
  Split header: open dropdown menus on hover (desktop only).
  - Only runs inside .header--split (the split menu header). Other headers/menus are untouched.
  - Only on screens 990px+ with a real mouse (hover: hover, pointer: fine).
    Touch devices and the mobile drawer keep Dawn's normal tap/click behaviour.
  - Uses the native <details> "open" state, so Dawn's own header-menu logic
    (aria-expanded, animation, close on outside click) keeps working.
  - Keyboard: Enter/Space on a menu item still toggles it like before.
*/
(function () {
  if (window.__headerSplitHoverInit) return;
  window.__headerSplitHoverInit = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isDesktop = window.matchMedia('(min-width: 990px)');
  var CLOSE_DELAY = 150; // ms, so the menu doesn't close while the mouse moves into it

  function hoverEnabled() {
    return canHover.matches && isDesktop.matches;
  }

  function setOpen(details, open) {
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeOtherTopLevel(menuRoot, current) {
    menuRoot.querySelectorAll('header-menu > details[open]').forEach(function (d) {
      if (d !== current) setOpen(d, false);
    });
  }

  function bind(root) {
    root.querySelectorAll('.header--split .header__inline-menu--split details').forEach(function (details) {
      var item = details.closest('li');
      if (!item || item.dataset.splitHover === 'true') return;
      item.dataset.splitHover = 'true';

      var isTopLevel = details.parentElement && details.parentElement.tagName === 'HEADER-MENU';
      var header = details.closest('.header--split');
      var summary = details.querySelector(':scope > summary');
      var closeTimer;

      item.addEventListener('mouseenter', function () {
        if (!hoverEnabled()) return;
        clearTimeout(closeTimer);
        if (isTopLevel && header) closeOtherTopLevel(header, details);
        setOpen(details, true);
      });

      item.addEventListener('mouseleave', function () {
        if (!hoverEnabled()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          setOpen(details, false);
        }, CLOSE_DELAY);
      });

      // With a mouse, clicking the item keeps it open instead of closing it.
      // Keyboard clicks (event.detail === 0) keep the normal toggle.
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (!hoverEnabled() || event.detail === 0) return;
          event.preventDefault();
          setOpen(details, true);
        });
      }
    });
  }

  function init() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-bind after the header section is reloaded
  document.addEventListener('shopify:section:load', init);
})();
 